import _ from 'lodash';

export default {
  getCategories
};

async function getCategories(menuBlob, loc_id) {
  if (!menuBlob || menuBlob.length === 0) return [];

  let jsonCategories = JSON.parse(menuBlob).menu_data || [];
  jsonCategories = _.filter(
    jsonCategories,
    (jsonCategory) => jsonCategory.Menu && jsonCategory.Menu.length > 0
  );
  let categories = jsonCategories.map((jsonCategory) => {
    let category = jsonCategory.Category;
    category.loc_id = loc_id;
    delete category.Menu;
    return category;
  });

  if (categories) return categories;

  throw new Error('Categories not found');
}
